import { getCurrentInstance } from 'vue';
import { compareVersion } from '~/common/utils';

export const getTemplateConfig = () => {
    const { $isAppEnvironment } = getCurrentInstance()?.proxy || {};

    const isActionWrapperAndCommentWrapperEnabled = () => {
        if (!$isAppEnvironment) {
            return true;
        }

        const { $appConfig } = getCurrentInstance()?.proxy || {};
        const appVersion = $appConfig?.appver;
        // 这里做版控原因
        // 互动区的展示需要先通过Google Play的审核，因此限制即将提审的版本1.8.2显示互动区
        // 后面当GP过审后，再改动代码，所有版本都显示互动区
        // todo @jinyao
        if (appVersion && compareVersion(appVersion, '1.8.2') >= 0) {
            return true;
        }

        return false;
    };

    return {
        photoAction: {
            commentLike: !$isAppEnvironment,
            actionWrapper: isActionWrapperAndCommentWrapperEnabled(),
            commentWrapper: isActionWrapperAndCommentWrapperEnabled(),
        },
    };
};
